import { render } from "./ProfileBlocCarousel.vue?vue&type=template&id=4dfd9a2c"
import script from "./ProfileBlocCarousel.vue?vue&type=script&lang=js"
export * from "./ProfileBlocCarousel.vue?vue&type=script&lang=js"
script.render = render

export default script